import React from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectMultiSearch from '../../../../Core/Fields/Floating/SelectMultiSearch';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';


function Tab1({ asnId,fields, setFields, supplierOptions, setselectedSupplierData, fieldErrors }) {
  console.log(fieldErrors, "fieldErrors_check");


  const handleChange = (field, value) => {
    console.log("working_new", field, value);

    const newFields = { ...fields, [field]: value };
    setFields(newFields);

    if (field === 'Supplier') {
      setselectedSupplierData(value);
    }
  };

  const handleSupplierChange = (newSelectedNotes) => {
    console.log(newSelectedNotes, "newSelectedNotes_came");
    setselectedSupplierData(newSelectedNotes)

  };
  return (
    <div className="row sidebarbox m-0" style={{ padding: "8px", borderRadius: "5px", maxHeight: "74vh", minHeight: "74vh", overflowY: "scroll" }}>
      <div style={{ maxHeight: "72vh" }}>

        <div className="firstcolor mb-2" >Shipment Basic Info</div>
              <div className="col mb-3">
          <Input
            label="ASN ID"
            value={asnId}
            readOnly
            className={fieldErrors.posting_date ? "error-border" : ""}

            style={{ height: "30px" }}
          />
        </div>
        <div className="col mb-3">
          <Input
            type='date'
            label="Posting Date"
            value={fields.posting_date}
            onChange={(e) => handleChange('posting_date', e.target.value)}
            className={fieldErrors.posting_date ? "error-border" : ""}
            readOnly

            style={{ height: "30px" }}
          />
        </div>

        <div className="col mb-3">
          <Input
            type='date'
            label="Estimated Arrival"
            value={fields.estimated_arrival}
            onChange={(e) => handleChange('estimated_arrival', e.target.value)}
            className={fieldErrors.estimated_arrival ? "error-border" : ""}
            disabled
            style={{ height: "30px" }}
            readOnly
          />
        </div>
 
        <div className="col mb-3">

          <SelectSearch
            list={supplierOptions}
            label="Select Supplier"
            // getOptionLabel={(item) => item.name}
            // getOptionValue={(item) => item.name}
            value={fields.Supplier}
            onChange={(value) => {
              handleChange('Supplier', value);
            }}
            className={fieldErrors.supplier ? "error-border" : ""}
            disabled

          />
        </div>
                <div className="col mb-3">
          <Input
            label="Company"
            value={fields.company}
            className={fieldErrors.company ? "error-border" : ""}
            readOnly


            style={{ height: "30px" }}
          />
        </div>

      </div>
    </div>
  );
}

export default Tab1;
